import { HttpInterceptorFn } from '@angular/common/http';
import { authMockHandler } from './auth.handler';
import { userMockHandler } from './user.handler';

/**
 * Mock API Handler
 * Combina todos los handlers mock en un único interceptor
 * Añade nuevos handlers importándolos y agregándolos al array
 */
export const mockApiHandler: HttpInterceptorFn = (req, next) => {
  // Lista de handlers - añadir nuevos handlers aquí
  const handlers: HttpInterceptorFn[] = [
    authMockHandler,
    userMockHandler,
    // Añadir más handlers aquí según se vayan creando
  ];

  // Ejecutar cada handler en orden hasta que uno maneje la petición
  for (const handler of handlers) {
    const result = handler(req, next);
    // Si el handler procesa la petición (no llama a next), retornamos ese resultado
    // Los handlers que no procesan la petición llamarán a next(req)
    if (result !== next(req)) {
      return result;
    }
  }

  // Si ningún handler procesó la petición, continuar con la petición normal
  return next(req);
};
